<div class="header-box-wrapper fw-500 fst-italic" [ngClass]="{ 'with-background': withBackground, 'no-background': !withBackground }">
  <h2 class="fst-italic">{{ text }}</h2>
</div>
